// extracted by mini-css-extract-plugin
export var caretAnchor = "_vo-0";
export var dropdownContent = "_vo-1";